import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../../constants/common'
import {
  AIButtonIconGradientDef,
  AIButtonIconGradientSvgPlacement,
  getAIButtonIconGradientStyleVars,
  useAIButtonIconGradientId,
} from '../../AIButton'
import { SelectDropdownEntityListItemContent } from '../../Select'

import * as styles from './AILengthDropdownItemContent.module.css'

function AILengthDropdownItemContent({
  avatarProps: {
    avatarClassName = styles.avatar,
    ...avatarProps
  } = EMPTY_OBJECT,
  isHovered,
  isSelected,
  style,
  value,
  ...restProps
}) {
  const avatarClassNameMod = classNames(avatarClassName, {
    [styles.avatarActive]: isHovered || isSelected,
  })

  const gradientId = useAIButtonIconGradientId(value?.value)

  return (
    <>
      <AIButtonIconGradientDef
        gradientId={gradientId}
        placement={AIButtonIconGradientSvgPlacement.Offscreen}
      />
      <SelectDropdownEntityListItemContent
        {...restProps}
        avatarProps={{ ...avatarProps, avatarClassName: avatarClassNameMod }}
        isHovered={isHovered}
        isSelected={isSelected}
        style={{
          ...style,
          ...getAIButtonIconGradientStyleVars(gradientId),
        }}
        value={value}
      />
    </>
  )
}

export default AILengthDropdownItemContent
